export class ProductScireum {

  constructor(
    public isNew: boolean = false,
    public sale: boolean = false,
    public clearance: boolean = false,
    public isNotOrderable: boolean = false,
    public hidden: boolean = false,
    public stockItem: boolean = false,
    public exportable: boolean = false,
    public specialistRetailer: boolean = false,
    public series?: string,
    public extendedKeyword?: string,
    public configuratorLink?: string,
    public ranking?: number,
    public oxomiHausmarkennummer?: string,
    public nordwestArtikelnummer?: string,
    public abweichendeLieferantennummer?: string ,
    public zusaetzlicherMatchCode?: string,
    public katalogartikelnummer?: string,
    public empfohleneMenge?: number,
    public befoerderungskategorie?: number,
    public artikellaengeMM?: number,
    public artikelbreiteMM?: number,
    public artikelhoeheMM?: number,
    public artikeltiefeMM?: number,
    public artikelGewichtKG?: number ,
    public volumen?: number,
    public warennummer?: string,
    public nurGewerblich: boolean = false,
    public lithiumbatterieEnthalten: boolean = false,
    public enthaeltElektrischeKomponenten: boolean = false,
    public ceKennzeichnung: boolean = false,
    public echadbhinterlegt: boolean = false,
    public ubaListKonform: boolean = false,
    public gefahrengutKlasse?: string ,
    public unNummer?: number,
    public offizielleBezeichnung?: string,
    public technischeBezeichnung?: string,
    public versandbezeichnung?: string,
    public gefahrenzettel?:string,
    public gefahrgutVerpackungsgruppe?: string,
    public anzahlGefahrgutVersandstuecke?: number,
    public beschreibungGefargutVersandstuecke?: string,
    public befoerderungskategorieGefahrgut?: number,
    public batteriepiktogramm?: number,
    public handelsname?: string,
    public brandPageLink?:string,
    public enthaeltHazardGoods: boolean = false
   


  ) {
  }
}

